// Frameworks, libraries, Contexts
import React from "react";

// Components
import CommitmentsTab from "components/CPCommittedCapacity/tabs/CommitmentsTab";

import { COMMITTED_CAPACITY_TITLE } from "constants/appConstants";
import { useSetTitle } from "helpers/formatters";

//CP Tabs removal commit included in CAREX-4199
const CPCommittedCapacity = () => {
  useSetTitle(COMMITTED_CAPACITY_TITLE)

  return (
    <div>
      <CommitmentsTab />
    </div>
  );
}

export default CPCommittedCapacity
